import { FormProvider, useForm } from 'react-hook-form'
import HookedField from 'components/HookedField'
import { PAYMENT_METHODS } from 'utils/constants'

const CustomerSubscriptionForm = ({ defaultValues = {} }) => {
  const methods = useForm({
    mode: 'onSubmit',
    shouldFocusError: true,
  })

  const planName =
    defaultValues?.plan?.preferredPlan?.descriptionEn ||
    defaultValues?.plan?.preferredPlan?.name ||
    ''

  const frequencyName =
    defaultValues?.frequency?.descriptionEn || defaultValues?.frequency?.name || ''

  const paymentMethodLabel = (() => {
    const paymentMethod = defaultValues?.paymentMethod
    const hasWallet = defaultValues?.walletAmount && Number(defaultValues.walletAmount) > 0

    if (hasWallet && paymentMethod && paymentMethod !== 'E-WALLET') {
      return PAYMENT_METHODS.WALLET + ' + ' + (PAYMENT_METHODS[paymentMethod] || paymentMethod)
    }
    if (hasWallet) return PAYMENT_METHODS.WALLET
    return paymentMethod ? PAYMENT_METHODS[paymentMethod?.replace('-', '')] || paymentMethod : ''
  })()

  return (
    <div className="customer-form">
      <FormProvider {...methods}>
        <form className="form" autoComplete="off">
          <fieldset className="form-fieldset">
            <div className="form-title">General info</div>
            <div className="form-grid">
              {defaultValues?.id && (
                <HookedField
                  label="ID"
                  name="id"
                  disabled={true}
                  defaultValue={defaultValues.id}
                  placeholder="id"
                  fieldType="textField"
                  type="text"
                />
              )}
              <HookedField
                label="Subscription Code"
                name="subscriptionSapId"
                disabled={true}
                defaultValue={defaultValues?.subscriptionSapId || ''}
                placeholder="Subscription Code"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Created Date"
                name="createdAt"
                disabled={true}
                defaultValue={defaultValues?.createdAt || null}
                placeholder="Created Date"
                fieldType="datePickerField"
                type="dateTimeField"
              />
              <HookedField
                label="Status"
                name="subscriptionStatus"
                disabled={true}
                defaultValue={defaultValues?.subscriptionStatus || ''}
                placeholder="Status"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Paused"
                name="isPaused"
                disabled={true}
                defaultValue={defaultValues?.isPaused ? 'Yes' : 'No'}
                placeholder="Paused"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Auto Renew"
                name="autoRenew"
                disabled={true}
                defaultValue={defaultValues?.autoRenew ? 'Yes' : 'No'}
                placeholder="Auto Renew"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Payment Method"
                name="paymentMethod"
                disabled={true}
                defaultValue={paymentMethodLabel}
                placeholder="Payment Method"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Wallet Amount"
                name="walletAmount"
                disabled={true}
                defaultValue={
                  defaultValues?.walletAmount != null
                    ? Number(defaultValues.walletAmount).toFixed(3)
                    : ''
                }
                placeholder="Wallet Amount"
                fieldType="textField"
                type="text"
              />
            </div>
          </fieldset>

          <fieldset className="form-fieldset">
            <div className="form-title">Customer info</div>
            <div className="form-grid">
              <HookedField
                label="Customer"
                name="user.fullName"
                disabled={true}
                defaultValue={defaultValues?.user?.fullName || ''}
                placeholder="Customer"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Customer SAP ID"
                name="user.sapId"
                disabled={true}
                defaultValue={defaultValues?.user?.sapId || ''}
                placeholder="Customer SAP ID"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Mobile"
                name="user.phoneNumber"
                disabled={true}
                defaultValue={defaultValues?.user?.phoneNumber || ''}
                placeholder="Mobile"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Email"
                name="user.email"
                disabled={true}
                defaultValue={defaultValues?.user?.email || ''}
                placeholder="Email"
                fieldType="textField"
                type="text"
              />
            </div>
          </fieldset>

          <fieldset className="form-fieldset">
            <div className="form-title">Plan & schedule</div>
            <div className="form-grid">
              <HookedField
                label="Plan"
                name="planName"
                disabled={true}
                defaultValue={planName}
                placeholder="Plan"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Frequency"
                name="frequencyName"
                disabled={true}
                defaultValue={frequencyName}
                placeholder="Frequency"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Subscription Amount"
                name="documentTotal"
                disabled={true}
                defaultValue={
                  defaultValues?.documentTotal != null
                    ? Number(defaultValues.documentTotal).toFixed(3)
                    : ''
                }
                placeholder="Subscription Amount"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Remaining Amount"
                name="balanceTotal"
                disabled={true}
                defaultValue={
                  defaultValues?.balanceTotal != null
                    ? Number(defaultValues.balanceTotal).toFixed(3)
                    : ''
                }
                placeholder="Remaining Amount"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Start Date"
                name="startDate"
                disabled={true}
                defaultValue={defaultValues?.startDate || null}
                placeholder="Start Date"
                fieldType="datePickerField"
                type="datePicker"
              />
              <HookedField
                label="End Date"
                name="endDate"
                disabled={true}
                defaultValue={defaultValues?.endDate || null}
                placeholder="End Date"
                fieldType="datePickerField"
                type="datePicker"
              />
              <HookedField
                label="Schedule At"
                name="scheduleAt"
                disabled={true}
                defaultValue={defaultValues?.scheduleAt || null}
                placeholder="Schedule At"
                fieldType="datePickerField"
                type="dateTimeField"
              />
              <HookedField
                label="Total Orders"
                name="scheduleTotalOrders"
                disabled={true}
                defaultValue={
                  defaultValues?.scheduleTotalOrders != null
                    ? String(defaultValues.scheduleTotalOrders)
                    : ''
                }
                placeholder="Total Orders"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Remaining Orders"
                name="scheduleRemainingOrders"
                disabled={true}
                defaultValue={
                  defaultValues?.scheduleRemainingOrders != null
                    ? String(defaultValues.scheduleRemainingOrders)
                    : ''
                }
                placeholder="Remaining Orders"
                fieldType="textField"
                type="text"
              />
            </div>
          </fieldset>

          <fieldset className="form-fieldset">
            <div className="form-title">Pause info</div>
            <div className="form-grid">
              <HookedField
                label="Paused Count"
                name="pausedCount"
                disabled={true}
                defaultValue={defaultValues?.pausedCount != null ? String(defaultValues.pausedCount) : ''}
                placeholder="Paused Count"
                fieldType="textField"
                type="text"
              />
              <HookedField
                label="Last Paused At"
                name="lastPausedAt"
                disabled={true}
                defaultValue={defaultValues?.lastPausedAt || null}
                placeholder="Last Paused At"
                fieldType="datePickerField"
                type="dateTimeField"
              />
              {/* <HookedField
                label="Pause Expires At"
                name="pauseExpiresAt"
                disabled={true}
                defaultValue={defaultValues?.pauseExpiresAt || null}
                placeholder="Pause Expires At"
                fieldType="datePickerField"
                type="datePicker"
              /> */}
            </div>
          </fieldset>
        </form>
      </FormProvider>
    </div>
  )
}

export default CustomerSubscriptionForm


